import styled from 'styled-components'

import { theme } from 'lib/styleUtils'

const Text = styled.p`
  padding: ${theme('spacing.base')};
`

export default Text
